module.exports = __webpack_public_path__ + "img/logo_small@2x.39d200f2.png";